export default {
    requiredField: 'Pole {{field}} je povinné.',
    shouldBeNumber: 'Pole {{field}} by malo byť číslo.',
    shouldBeString: 'Pole {{field}} by mal byť reťazec.',
    stringShouldHaveMinLength: "V poli {{field}} použite minimálne {{minLength}} $t(common:char, {'count': {{minLength}}}).",
    stringShouldHaveMaxLength: "V poli {{field}} použite maximálne {{maxLength}} $t(common:char, {'count': {{maxLength}}}).",
    stringShouldHaveLength: "V poli {{field}} použite {{length}} $t(common:char, {'count': {{length}}}).",
    numberMinValue: 'V poli {{field}} použite číslo väčšie alebo rovné {{min}}.',
    numberMaxValue: 'V poli {{field}} použite číslo rovné alebo menšie ako {{max}}.',
    emailShouldContainAt: "Email by mal obsahovať zavináč - '@'.",
    emailShouldContainDomain: "Email by mal obsahovať doménu. Napríklad '.sk' alebo'.com'.",
    emailShouldHaveValidFormat: "Email by mal byť v správnom formáte. Napríklad 'vase@meno.sk'",
    emailContainsDiacritics: 'Email nesmie obsahovať diakritiku.',
    emailDomainContainsValidChars: 'E-mail nesmie obsahovať diakritiku a nepovolené znaky',
    incorrectDateInserted: 'Deň v mesiaci v poli {{field}} nie je uvedený správne.',
    incorrectMonthInserted: 'Mesiac v roku v poli {{field}} nie je uvedený správne.',
    incorrectYearInserted: 'Rok v poli {{field}} nie je uvedený správne.',
    incorrectDateFormat: 'Formát dátumu v poli {{field}} nie je správný. Vložte dátum vo formáte {{format}}',
    dateNotBefore: 'Dátum v poli {{field}} musí predchádzať dátumu {{before, DD.MM.YYYY}}.',
    dateNotAfter: 'Dátum v poli {{field}} musí následovať za dátumom {{after, DD.MM.YYYY}}.',
    birthNumberNotCorrect: 'Vložené rodné číslo nie je platné.',
    birthNumberContainsSlash: 'Prosím, odstráňte vložené lomítko.',
    icNotCorrect: 'Vložené IČ nie je platné.',
    shouldHaveNoWhitespaces: '{{field}} nesmie obsahovať medzeri.',
    shouldHaveNoPunctation: '{{field}} nesmie obsahovať interpunkčné znamienka ako napr. bodky, čiarky, ale zátvorky.',
    shouldHaveNoPunctationStrict: 'Pole {{field}} obsahuje nepovolené znaky.',
    onlyAllowedChars: 'Pole {{field}} obsahuje nepovolené znaky.',
    shouldHaveOnlyDigits: 'Pole {{field}} môže obsahovať iba číslice.',
    isAlphanumerical: 'Pole {{field}} môže obsahovať iba písmená alebo číslice.',
    isAlphanumericalUpper: 'Pole {{field}} môže obsahovať iba veľké písmená a číslice.',
    isAlphanumericalLower: 'Pole {{field}} môže obsahovať iba malé písmená a číslice.',
    companyNameIncorrect: 'Pole {{field}} obsahuje neplatné znaky.',
    phoneIncorrect: 'Telefónne číslo nie je správne. Zadajte buď 12 znakov s + na začiatku, alebo 9 číslic.',
    wrongExtension: 'Nepodporovaný formát súboru',
    wrongSize: 'Nepodporovaná veľkosť súboru',
    wrongSizeDropzone: '<strong>{{fieldValueIndexed.name}}</strong> je príliš veľký ({{sizeMb, number(style: unit; unit: megabyte)}})',
    uploadTotalMaxSize: 'Celková veľkosť súborov prekročila limit {{maxSizeMb, number(style: unit; unit: megabyte)}} (celkom: {{sizeMb, number(style: unit; unit: megabyte)}})',
    wrongExtensionDropzone: '<strong>{{fieldValueIndexed.name}}</strong> má nepodporovanú príponu súboru',
    uploadHasError: 'Pole {{field}} obsahuje nepovolené súbory.',
    incorrectVinFormat: 'Nesprávny VIN formát',
    incorrectVatFormat: 'Nesprávny DIČ formát',
    zipNotCorrect: 'Nesprávny formát PSČ',
    uploadMaxNumOfFiles: "Môžete nahrať maximálne {{numOfFiles}} $t(common:file, {'count': {{numOfFiles}}})."
};
